import { useMutation } from "react-query";
import http from "infra/http";
import { PrevisaoOrcamentrariaParametros } from "../typings";

function useSaveParametroPrevisaoOrcamentaria() {
  return useMutation(
    (data: PrevisaoOrcamentrariaParametros) => {
      return http.put(`/v1/previsao-orcamentaria/parametros`, data);
    },
    { retry: false }
  );
}

export default useSaveParametroPrevisaoOrcamentaria;
